import { Box, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React from "react";
import { NavLink } from "react-router-dom";
import PeopleRoundedIcon from "@material-ui/icons/PeopleRounded";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";

export const TeamNavigation: React.FC = () => {
  const { teamName: storedTeamName } = useCurrentTeam();
  const teamId = useSelector((state: any) => state?.userManager?.team ?? storedTeamName);

  if(!teamId) {
    return null;
  }
  return (
    <NavLink
      className="navigation-tab"
      key={"applications"}
      activeClassName="active"
      to={`/home/teams/${teamId}`}
    >
      <ListItem button>
        <ListItemIcon>
          <PeopleRoundedIcon style={{ color: "#fff" }} />
        </ListItemIcon>
        <ListItemText
          className="sub-menu-text"
          primary={
            <Box display="flex">
              <Box flexGrow={1}>Teams</Box>
            </Box>
          }
        />
      </ListItem>
    </NavLink>
  );
};
